import { render, staticRenderFns } from "./twoMenuBox.vue?vue&type=template&id=b0bec1b2&scoped=true"
import script from "./twoMenuBox.vue?vue&type=script&lang=js"
export * from "./twoMenuBox.vue?vue&type=script&lang=js"
import style0 from "./twoMenuBox.vue?vue&type=style&index=0&id=b0bec1b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bec1b2",
  null
  
)

export default component.exports